export default "__VITE_ASSET__CCGhRAxu__"